import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import { useEffect } from "react";
import { useDownloadFile } from "src/shared/data-access/downloadFile/useDownloadFile";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "src/shared/context/useAuth";

export default function DocumentDownloadPage() {
  const params = useLocation();
  const urlParams = new URLSearchParams(params.search);
  const { t } = useTranslation();
  const { mutate: fileDownload, isLoading: isLoadingFile } = useDownloadFile();
  const navigate = useNavigate();
  const { userHomePath, authenticated } = useAuth();
  useEffect(() => {
    const fileParams: { key: string; value: string }[] = [];
    urlParams.forEach((value, key) => fileParams.push({ key, value }));
    if (fileParams.length > 0) {
      fileDownload({
        url: "document/download",
        params: fileParams,
      });
    } else if (!authenticated || fileParams.length === 0) {
      navigate(userHomePath);
    }
  }, []);

  return (
    <Box
      sx={{
        width: "80vw",
        display: "flex",
        mx: "auto",
        flexDirection: "column",
        minHeight: "80vh",
      }}
    >
      <Paper sx={{ padding: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          {isLoadingFile ? (
            <>
              <Box
                sx={{
                  position: "relative",
                  display: "inline-flex",
                  mb: 2,
                }}
              >
                <CircularProgress size={60} thickness={4} color="primary" />
              </Box>
              <Typography
                variant="h5"
                component="h2"
                gutterBottom
                sx={{ color: "#003a70" }}
              >
                {t("Λήψη Αρχείου")}
              </Typography>
              <Typography variant="body1" color="text.secondary" paragraph>
                {t(
                  "Παρακαλώ περιμένετε όσο προετοιμάζουμε το αρχείο σας για λήψη...",
                )}
              </Typography>
            </>
          ) : (
            <>
              <CheckCircleIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
              <Typography
                variant="h5"
                component="h2"
                gutterBottom
                sx={{ color: "#003a70" }}
              >
                {t("Η Λήψη Ολοκληρώθηκε!")}
              </Typography>
              <Typography variant="body1" paragraph>
                {t("Το αρχείο σας έχει ληφθεί με επιτυχία.")}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t(
                  "Μπορείτε τώρα να κλείσετε αυτό το παράθυρο ή να ελέγξετε το φάκελο λήψεων σας.",
                )}
              </Typography>
            </>
          )}
        </Box>
      </Paper>
    </Box>
  );
}
